// Mock data for BelBel clone (Sidoarjo Powder Drink)

export const siteConfig = {
  brand: 'BelBel',
  brandFull: 'Sidoarjo Powder',
  tagline: 'Supplier Bubuk Minuman Premium',
  whatsappNumber: '6281217532692',
  whatsappNumberSolo: '6281217532692',
  instagram: 'https://www.instagram.com/belbel.powder',
  shopee: 'https://s.shopee.co.id/5q6tiI4qUQ?share_channel_code=1',
  tokopedia: 'https://vt.tiktok.com/ZSXEwx62Q/?page=Mall',
  email: 'info@belbel.co.id',
  waMessage: 'Halo Kak! Saya tertarik dengan bubuk minuman BelBel. Boleh minta info harga dan minimum order-nya?'
};

export const navigation = [
  { label: 'Beranda', path: '/' },
  {
    label: 'Tentang BelBel',
    path: '/tentang',
    submenu: [
      { label: 'Profil Perusahaan', path: '/tentang' },
      { label: 'Visi & Misi', path: '/tentang#visi-misi' },
      { label: 'Sertifikasi', path: '/tentang#sertifikasi' }
    ]
  },
  {
    label: 'Produk',
    path: '/produk',
    submenu: [
      { label: 'Semua Produk', path: '/produk' },
      { label: 'Varian Kopi', path: '/produk?kategori=kopi' },
      { label: 'Varian Teh', path: '/produk?kategori=teh' },
      { label: 'Varian Cokelat', path: '/produk?kategori=cokelat' },
      { label: 'Varian Buah', path: '/produk?kategori=buah' }
    ]
  },
  { label: 'Agen & Cabang', path: '/agen' },
  { label: 'Artikel', path: '/artikel' },
  { label: 'Kontak', path: '/kontak' }
];

export const heroSlides = [
  {
    title: 'Bubuk Minuman Premium Terlengkap',
    subtitle: 'Bikin pelangganmu repeat order hanya dengan bubuk minuman premium terlengkap dari BelBel (Sidoarjo Powder).',
    image: 'https://images.unsplash.com/photo-1633509817627-5a29634475af?w=900&q=80',
    ctaPrimary: 'Pesan Sekarang',
    ctaSecondary: 'Lihat Semua Produk'
  }
];

export const aboutFeatures = [
  {
    title: 'Varian Rasa Terlengkap',
    items: ['Varian Kopi', 'Varian Teh', 'Varian Buah-buahan', 'Varian Cokelat'],
    icon: 'Coffee'
  },
  {
    title: 'Kualitas Premium',
    items: ['Tanpa Filler', 'Tanpa Pemanis Buatan', 'Tanpa Pengawet', 'Tanpa Pewarna Kimia'],
    icon: 'Sparkles'
  },
  {
    title: 'Jelas Aman',
    items: ['Bersertifikat Halal', 'Ijin Edar Dinkes PIRT', 'Higienis & Terjamin', 'Diproduksi Profesional'],
    icon: 'ShieldCheck'
  }
];

export const productCategories = [
  { id: 'all', label: 'Semua' },
  { id: 'kopi', label: 'Kopi' },
  { id: 'teh', label: 'Teh' },
  { id: 'cokelat', label: 'Cokelat' },
  { id: 'buah', label: 'Buah-buahan' },
  { id: 'milkshake', label: 'Milkshake' }
];

export const products = [
  { id: 1, name: 'Choco Caramel', category: 'cokelat', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1577805947697-89e18249d767?w=600&q=80', shopee: 'https://shopee.co.id/BelBel-Bubuk-Minuman-Choco-Caramel-1-kg-i.156583749.2651560615', tokopedia: 'https://www.tokopedia.com/japo-powderdrink/bubuk-minuman-rasa-choco-caramel-powder-choco-caramel-1-kg' },
  { id: 2, name: 'Cocoa Mix', category: 'cokelat', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1606791405792-1004f1718d0c?w=600&q=80', shopee: 'https://shopee.co.id/BelBel-Bubuk-Minuman-Choco-Delfi-1-Kg-i.156583749.2665919898', tokopedia: 'https://www.tokopedia.com/japo-powderdrink/bubuk-minuman-rasa-coklat-choco-delfi-1-kg' },
  { id: 3, name: 'Choco Original', category: 'cokelat', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.pexels.com/photos/5908466/pexels-photo-5908466.jpeg?w=600&auto=compress', shopee: 'https://shopee.co.id/BelBel-Bubuk-Minuman-Choco-Original-1-Kg-i.156583749.2651450870', tokopedia: 'https://www.tokopedia.com/japo-powderdrink/bubuk-minuman-rasa-coklat-choco-original-dark-choco-1-kg' },
  { id: 4, name: 'Lemon Tea', category: 'teh', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=600&q=80', shopee: 'https://shopee.co.id/BelBel-Bubuk-Minuman-Lemon-Tea-1-kg-i.156583749.2651618970', tokopedia: 'https://www.tokopedia.com/japo-powderdrink/powder-lemon-tea-1-kg' },
  { id: 5, name: 'Lychee Tea', category: 'teh', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1693996045463-6ea86d10a2e7?w=600&q=80', shopee: 'https://shopee.co.id/BelBel-Bubuk-Minuman-Lychee-Tea-1-kg-i.156583749.2651600384', tokopedia: 'https://www.tokopedia.com/japo-powderdrink/bubuk-minuman-lychee-tea-leci-tea' },
  { id: 6, name: 'Milk Tea', category: 'teh', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1617825295690-28ae56c56135?w=600&q=80', shopee: 'https://shopee.co.id/BelBel-Bubuk-Minuman-Milk-Tea-1-kg-i.156583749.2649488810', tokopedia: 'https://www.tokopedia.com/japo-powderdrink/bubuk-minuman-teh-milk-tea-powder' },
  { id: 7, name: 'Thai Tea', category: 'teh', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.pexels.com/photos/3847479/pexels-photo-3847479.jpeg?w=600&auto=compress', shopee: '#', tokopedia: '#' },
  { id: 8, name: 'Matcha Green Tea', category: 'teh', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1515823064-d6e0c04616a7?w=600&q=80', shopee: '#', tokopedia: '#' },
  { id: 9, name: 'Cappucino', category: 'kopi', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1572442388796-11668a67e53d?w=600&q=80', shopee: '#', tokopedia: '#' },
  { id: 10, name: 'Coffee Latte', category: 'kopi', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=600&q=80', shopee: '#', tokopedia: '#' },
  { id: 11, name: 'Strawberry', category: 'buah', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=600&q=80', shopee: '#', tokopedia: '#' },
  { id: 12, name: 'Blueberry', category: 'buah', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1498557850523-fd3d118b962e?w=600&q=80', shopee: '#', tokopedia: '#' },
  { id: 13, name: 'Avocado', category: 'buah', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1601039641847-7857b994d704?w=600&q=80', shopee: '#', tokopedia: '#' },
  { id: 14, name: 'Jagung Manis', category: 'buah', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1601472541319-e3a5c2f3f75d?w=600&q=80', shopee: '#', tokopedia: '#' },
  { id: 15, name: 'Vanilla Milkshake', category: 'milkshake', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=600&q=80', shopee: '#', tokopedia: '#' },
  { id: 16, name: 'Taro Milkshake', category: 'milkshake', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1541107829776-3c9e9cbbb37f?w=600&q=80', shopee: '#', tokopedia: '#' },
  { id: 17, name: 'Red Velvet', category: 'milkshake', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1586348943529-beaae6c28db9?w=600&q=80', shopee: '#', tokopedia: '#' },
  { id: 18, name: 'Hazelnut', category: 'kopi', packaging: 'Powder Mix Gula (1 kg)', image: 'https://images.unsplash.com/photo-1497935586351-b67a49e012bf?w=600&q=80', shopee: '#', tokopedia: '#' }
];

export const testimonials = [
  { name: 'Arifrs', flavor: 'Durian', quote: 'Datang dengan selamat dan aman. Selalu cepat. Terimakasih kak, saya suka saya suka' },
  { name: 'Ilham', flavor: 'Hazelnut Plain', quote: 'Rasa: enak. Harga: murah. Kualitas: baik. Alhamdulillah paket sampai sesuai pesanan, dan kondisi dalam keadaan baik pembungkusan rapih dan cepat' },
  { name: 'Iis', flavor: 'Choco Silverqueen', quote: 'Harga: terjangkau. Bagussssssss.... recomended banget no debat!' },
  { name: 'Asep', flavor: 'Thai Tea', quote: 'Udah langganan nih rasa Thai tea nya semua pada suka, mantul pokonya.' },
  { name: 'Zafira', flavor: 'Vanilla', quote: 'Vanilanya berasa banget gurihnya dapet. Kualitas: FIX PREMIUM. Cocok banget buat temen minum diwaktu panas.' },
  { name: 'Dewi Dwitya', flavor: 'Cappucino', quote: 'Rasa enak, kualitas premium, harga ramah di kantong, selalu langganan, thank you..' },
  { name: 'Saripuspita', flavor: 'Red Velvet', quote: 'Pengiriman cepat dan pengemasan aman, rasa enak dan mewah..' },
  { name: 'Aji', flavor: 'Taro', quote: 'Seller responsif bgt.. semoga japo selalu berkreasi dgn rasa2 yg lain.. dan saya akan jadikan toko ini langganan saya..' },
  { name: 'Khoirudin', flavor: 'Dark Choco', quote: 'Udah kesekian kali beli disini, bubuk dark choco nya enak rasanya manisnya juga pas. Terimakasih seller' },
  { name: 'Neny', flavor: 'Choco Caramel', quote: 'Beli banyak packing pake dus no wrap, untung aman, selalu langganan deh, thank you..' }
];

export const branches = [
  {
    id: 1,
    title: 'Toko Cabang Kemayoran',
    region: 'Jakarta Pusat',
    address: 'Samping SMK 54 Jakarta, Gg. Panca 7 No.1A, RT.14/RW.1, Serdang, Kec. Kemayoran, Kota Jakarta Pusat, DKI Jakarta 10650',
    mapLink: 'https://g.page/BelBel_KEMAYORAN?share',
    whatsapp: '6281217532692',
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=800&q=80'
  },
  {
    id: 2,
    title: 'Toko Cabang Solo',
    region: 'Solo, Jawa Tengah',
    address: 'Inti Permata Regency Blok A37 Ngiri, Sapen, Jaten, Solo (Belakang SPBU Sapen)',
    mapLink: 'https://www.google.com/maps/place/BelBel+Jakarta+Powder',
    whatsapp: '6281217532692',
    image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=800&q=80&sat=-50'
  },
  {
    id: 3,
    title: 'Toko Cabang Pamulang',
    region: 'Tangerang Selatan',
    address: 'Perumahan Serua Permai Blok A12 No. 4, Jl. Merdeka Raya, Serua, Ciputat - Tangerang Selatan 15415',
    mapLink: 'https://goo.gl/maps/kGSqckaF9Z75UZb5A',
    whatsapp: '6281217532692',
    image: 'https://images.unsplash.com/photo-1521295121783-8a321d551ad2?w=800&q=80'
  }
];

export const articles = [
  {
    id: 1,
    slug: 'tips-usaha-minuman-kekinian',
    title: '7 Tips Sukses Memulai Usaha Minuman Kekinian di 2025',
    excerpt: 'Bisnis minuman kekinian masih terus tumbuh. Simak tips memilih bahan baku bubuk minuman berkualitas untuk usaha Anda.',
    image: 'https://images.unsplash.com/photo-1517701550927-30cf4ba1dba5?w=800&q=80',
    author: 'Tim BelBel',
    date: '15 Sep 2025',
    category: 'Bisnis'
  },
  {
    id: 2,
    slug: 'perbedaan-bubuk-minuman-premium',
    title: 'Perbedaan Bubuk Minuman Premium & Biasa: Panduan Lengkap',
    excerpt: 'Kenali ciri-ciri bubuk minuman berkualitas premium agar tidak salah pilih supplier untuk usaha Anda.',
    image: 'https://images.unsplash.com/photo-1577805947697-89e18249d767?w=800&q=80',
    author: 'Tim BelBel',
    date: '02 Sep 2025',
    category: 'Edukasi'
  },
  {
    id: 3,
    slug: 'resep-thai-tea-signature',
    title: 'Resep Thai Tea Signature: Nikmat & Menguntungkan',
    excerpt: 'Coba resep Thai Tea andalan dengan bubuk premium BelBel. HPP rendah, rasa juara, pelanggan pasti balik lagi.',
    image: 'https://images.unsplash.com/photo-1558857563-c0c6ee6ff8bd?w=800&q=80',
    author: 'Tim BelBel',
    date: '25 Agu 2025',
    category: 'Resep'
  },
  {
    id: 4,
    slug: 'peluang-agen-japo',
    title: 'Peluang Menjadi Agen BelBel: Untung Berlipat, Modal Ringan',
    excerpt: 'Bergabunglah menjadi agen resmi BelBel dan nikmati keuntungan bisnis bubuk minuman terpercaya sejak 2013.',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    author: 'Tim BelBel',
    date: '10 Agu 2025',
    category: 'Kemitraan'
  },
  {
    id: 5,
    slug: 'cara-menyeduh-bubuk-japo',
    title: 'Cara Menyeduh Bubuk Minuman BelBel agar Rasanya Maksimal',
    excerpt: 'Ikuti panduan seduh yang benar untuk mendapatkan rasa yang konsisten dan disukai pelanggan.',
    image: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=800&q=80',
    author: 'Tim BelBel',
    date: '01 Agu 2025',
    category: 'Tutorial'
  },
  {
    id: 6,
    slug: 'inovasi-varian-baru',
    title: 'Inovasi Varian Baru BelBel Tahun 2025',
    excerpt: 'BelBel merilis 5 varian rasa baru yang siap memanjakan lidah pelanggan Anda. Cek daftar lengkapnya!',
    image: 'https://images.unsplash.com/photo-1560717845-968823efbee1?w=800&q=80',
    author: 'Tim BelBel',
    date: '20 Jul 2025',
    category: 'Produk Baru'
  }
];

export const stats = [
  { value: '18 Th', label: 'Tahun Pengalaman' },
  { value: '100+', label: 'Varian Rasa' },
  { value: '100%', label: 'Halal BPOM' },
];

export const marketplaces = [
  {
    name: 'Shopee',
    url: 'https://s.shopee.co.id/5q6tiI4qUQ?share_channel_code=1',
    logo: '/images/logo-shopee.png',
    bg: 'bg-orange-50',
    cta: 'Toko Shopee BelBel',
  },
  {
    name: 'TikTok Shop',
    url: 'https://vt.tiktok.com/ZSXEwx62Q/?page=Mall',
    logo: '/images/logo-tiktok-shop.png',
    bg: 'bg-gray-50',
    cta: 'Toko TikTok Shop Belbel',
  },
];
